/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RegisteredCompanyInput} from "./registeredCompanyInput.zod";

export const UpdateRepresentativeRequest = zod.object({
  company: RegisteredCompanyInput,
  logoUrl: zod.string().optional(),
  exclusive: zod.boolean(),
});

export type UpdateRepresentativeRequest = zod.input<typeof UpdateRepresentativeRequest>;
export type UpdateRepresentativeRequestOutput = zod.output<typeof UpdateRepresentativeRequest>;
